import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import Timer = NodeJS.Timer;

import { LoaderButtonState } from './button-status';

@Component({
  selector: 'ls-button',
  templateUrl: './button.component.html'
})
export class ButtonComponent implements OnInit, OnDestroy {
  @Input()
  public attachedForm = '';
  @Input()
  public buttonText = '';
  @Input()
  public responsive = true;
  @Input()
  public className = 'o-button--light';
  @Input()
  public disabled = false;

  private buttonTimeout = 5000;
  private _buttonStatus = '';
  private timeOut: Timer;

  public ngOnInit(): void {
    this._buttonStatus = LoaderButtonState.NORMAL;
  }

  public ngOnDestroy(): void {
    clearTimeout(this.timeOut);
  }

  @Input()
  public set buttonStatus(buttonStatus: string) {
    if (buttonStatus === LoaderButtonState.DONE) {
      this.timeOut = setTimeout(() => {
        this._buttonStatus = LoaderButtonState.NORMAL;
      }, this.buttonTimeout);
    }
    this._buttonStatus = buttonStatus;
  }

  public get buttonStatus(): string {
    return this._buttonStatus;
  }

  public get isLoading(): boolean {
    return (
      this._buttonStatus === LoaderButtonState.LOADING ||
      (!!this.className && this.className.includes(LoaderButtonState.LOADING))
    );
  }
}
